import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from 'src/utils/ui-messages'
import GoBack from '../icons/ui/GoBack'
import { Button } from '@mobiscroll/react-latest'
import { handleRedirect } from 'src/utils'

const BackToList = ({ link, className }: { link: string; className: string }) => (
  <div className={`${className} relative flex items-center pl2`}>
    <Button
      ariaLabel='Back button'
      className='mbsc-btn-with-start-icon mbsc-flat-btn'
      onClick={() => handleRedirect(link)}
    >
      {UIMessages.common.backToList}
    </Button>
    <GoBack className='absolute icon--small ml2 z1' />
  </div>
)

export default BackToList



// WEBPACK FOOTER //
// ./src/components/ui/BackToList.tsx